import React, { RefObject } from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';

import FooterStyle from './style';

import HubspotContactForm from 'src/components/organisms/b2bLandingPage/hubsport';

type FooterProps = {
  contactUsFormRef: RefObject<HTMLDivElement>;
};

const Footer = ({ contactUsFormRef }: FooterProps) => {
  const { t } = useTranslation('business');
  const { t: tCommon } = useTranslation('common');

  return (
    <FooterStyle>
      <div className="container">
        <div className="join-us-container">
          <Typography className="title1">{t('improve_skill_extend_organization_potential')}</Typography>
          <Typography className="title2">{t('skilllane_b2b')}</Typography>
          <Typography className="detail">{t('course_online_self_learning')}</Typography>
          <div ref={contactUsFormRef}>
            <Typography className="title2">{t('join_us')}</Typography>
          </div>
          <div className="hubsport-contact-form">
            <HubspotContactForm region="na1" portalId="4284733" formId="9cb5cb9d-0653-42c5-bd0d-2851dda9106d" />
          </div>
        </div>

        <Typography className="remark">*{t('base_on_thai_course_online')}</Typography>
        <Divider />
        <div className="footer-container">
          <div className="logo-container">
            <img className="logo" src="/static/icons/skl-bu-logo-white.svg" alt="SkillLane" />
            <Typography>{tCommon('copy_right')}</Typography>
          </div>
          <div className="contact-us-container">
            <Typography fontWeight="bold">{tCommon('contact_us')}</Typography>
            <a href="mailto:b2b.info@SkillLane.com" target="_blank" rel="noreferrer">
              <Box className="contact-box">
                <EmailIcon /> <Typography className="email">b2b.info@SkillLane.com</Typography>{' '}
                <ChevronRightIcon className="arrow" />
              </Box>
            </a>
            <a href="tel:061-420-6317" target="_blank" rel="noreferrer">
              <Box className="contact-box">
                <PhoneIcon /> 061-420-6317 <ChevronRightIcon className="arrow" />
              </Box>
            </a>
          </div>
        </div>
      </div>
    </FooterStyle>
  );
};

export default Footer;
